import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import CreateOldGoldEntryForm from './CreateOldGoldEntryForm'
function CreateOldGoldEntry() {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>old-gold-entry-form</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <CreateOldGoldEntryForm />
            </div>
        </div>


    )
}

export default CreateOldGoldEntry
